module.exports = __webpack_public_path__ + "img/emptyBox.3ac5e9d1.svg";